import * as React from 'react';
import * as header from './headerWithPartner.module.scss';

export const HeaderWithPartner = () => {
  return (
    <div className={header.topLogo}>
      <div className={header.logo}>
        <a href="/">
          <img
            src={"https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg"}
            alt={'Advance Club'}
          />
        </a>
        <img
          className={header.logo__partner}
          src={"https://fs.advance.ru/landing-pages/partners/foxford/foxford.svg"}
          alt={'Foxford'}
        />
      </div>
      <a href="tel:88007005342">
        <span className={header.phone} style={{ color: '#282019' }}>
          8 (800) 700-53-42
        </span>
      </a>
    </div>
  );
};
